import { render, staticRenderFns } from "./pengdingOrders.vue?vue&type=template&id=2bf4be35&scoped=true&"
import script from "./pengdingOrders.vue?vue&type=script&lang=js&"
export * from "./pengdingOrders.vue?vue&type=script&lang=js&"
import style0 from "./pengdingOrders.vue?vue&type=style&index=0&id=2bf4be35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4be35",
  null
  
)

export default component.exports